import { betterAuth } from 'better-auth';
import { bearer, genericOAuth } from 'better-auth/plugins';
import { createAuthClient } from 'better-auth/react';

export const auth = betterAuth({
	account: {
		storeAccountCookie: true
	},
	plugins: [
		bearer(),
		genericOAuth({
			config: [
				{
					providerId: 'okta',
					clientId: process.env.OKTA_CLIENT_ID || '',
					clientSecret: process.env.OKTA_CLIENT_SECRET || '',
					discoveryUrl: `https://${ process.env.OKTA_URL }/.well-known/openid-configuration`,
					scopes: [ 'openid', 'profile', 'email' ]
				}
			]
		})
	],
	session: {
		cookieCache: {
			enabled: true,
			maxAge: 600,
			refreshCache: {
				updateAge: 60
			}
		}
	}
});

export type Session = typeof auth.$Infer.Session;

export const authClient = createAuthClient();
